// Theme Toggle
const themeToggle = document.getElementById('theme-toggle');
if (themeToggle) {
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark');
  }

  themeToggle.addEventListener('click', () => {
    document.documentElement.classList.toggle('dark');
    const isDark = document.documentElement.classList.contains('dark');
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
  });
}

// Supabase Integration
import { createClient } from 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2/+esm'

const supabaseUrl = 'https://zbbzhpxxygsidgvapxzc.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpiYnpocHh4eWdzaWRndmFweHpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE1MzQ5ODEsImV4cCI6MjA4NzExMDk4MX0.b6VOnOmc9Sa8W5NJRTxxywR4FRThjzGdJkuK8U0EpMM'
const supabase = createClient(supabaseUrl, supabaseKey)

// Check authentication state
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN') {
    console.log('User signed in:', session.user)
    // Redirect to React dashboard after successful login
    if (window.location.pathname.includes('login.html') || window.location.pathname.includes('signup.html')) {
      window.location.href = '/app.html#/dashboard'
    }
  } else if (event === 'SIGNED_OUT') {
    console.log('User signed out')
    // Redirect to login if on protected pages
    if (window.location.pathname.includes('app.html')) {
      window.location.href = 'login.html'
    }
  }
})

// Login Form Handler
const loginForm = document.getElementById('login-form');
if (loginForm && window.location.pathname.includes('login.html')) {
  loginForm.addEventListener('submit', async (e) => {
    e.preventDefault()
    const email = document.getElementById('email').value
    const password = document.getElementById('password').value

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      })

      if (error) throw error

      // Success - redirect will happen automatically via onAuthStateChange
      console.log('Login successful')
    } catch (error) {
      alert('Error signing in: ' + error.message)
      console.error('Login error:', error)
    }
  })
}

// Signup Form Handler
const signupForm = document.getElementById('signup-form');
if (signupForm && window.location.pathname.includes('signup.html')) {
  signupForm.addEventListener('submit', async (e) => {
    e.preventDefault()
    const fullName = document.getElementById('name').value
    const email = document.getElementById('email').value
    const password = document.getElementById('password').value

    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName,
          }
        }
      })

      if (error) throw error

      alert('Success! Please check your email to verify your account.')
      console.log('Signup successful')
    } catch (error) {
      alert('Error signing up: ' + error.message)
      console.error('Signup error:', error)
    }
  })
}

// Dashboard - Check if user is authenticated
if (window.location.pathname.includes('app.html')) {
  supabase.auth.getSession().then(({ data: { session } }) => {
    if (!session) {
      window.location.href = 'login.html'
    }
  })
}

// Logout handler
const logoutButton = document.getElementById('logout-btn');
if (logoutButton) {
  logoutButton.addEventListener('click', async () => {
    await supabase.auth.signOut()
    window.location.href = 'index.html'
  })
}
